import { FiDollarSign, FiUsers, FiBarChart2, FiLayers, FiShield, FiCalendar, FiTag, FiBook } from 'react-icons/fi';
import styles from './LandingLayout.module.css';

const FEATURES = [
  { icon: <FiDollarSign />, title: 'Donation Management',         desc: 'Track donations by type, category, and group with multiple items per entry and a draft/submit workflow.' },
  { icon: <FiTag />,        title: 'Donation Offers',             desc: 'Members commit donation offers and the system tracks payments against them, updating offer status automatically.' },
  { icon: <FiUsers />,      title: 'Family Management',           desc: 'Create and manage families within your Derasar. Head approves members and tracks family contributions.' },
  { icon: <FiBarChart2 />,  title: 'Reports & Analytics',         desc: 'Balance sheet, income & expenditure, category fund, donation offer ageing, day book, and cash book reports.' },
  { icon: <FiLayers />,     title: 'Multi-Derasar Support',       desc: 'Join multiple Derasars, switch between them, and keep all records cleanly separated per Derasar.' },
  { icon: <FiShield />,     title: 'Role-Based Access',           desc: 'Super admin, Derasar admin, and member roles with granular access control on every feature.' },
  { icon: <FiCalendar />,   title: 'Financial Year Management',   desc: 'Scope all accounting to a financial year. Set opening balances and close years with a full audit trail.' },
  { icon: <FiBook />,       title: 'Double-Entry Ledger',         desc: 'Full chart of accounts: LedgerGroup → SubGroup → Account. System groups are read-only; admins create sub-accounts.' },
];

const FeaturesPage = () => (
  <section className={styles.section}>
    <div className={styles.sectionInner}>
      <div className={styles.sectionLabel}>Platform Features</div>
      <h2 className={styles.sectionTitle}>Everything Your Derasar Needs</h2>
      <p className={styles.sectionLead}>
        From daily donations to year-end financial statements, every tool is built
        specifically for Jain temple organisations.
      </p>
      <div className={styles.featuresGrid}>
        {FEATURES.map(f => (
          <div key={f.title} className={styles.featureCard}>
            <div className={styles.featureIcon}>{f.icon}</div>
            <h3>{f.title}</h3>
            <p>{f.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default FeaturesPage;
